<script>
export default {
  name: 'ChevronDownSVG',
  props: {
    color: {
      type: String,
      default: '#4D4D4D'
    }
  }
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g id="icon-navigation-expand_more_24px" transform="translate(20 20) rotate(180)">
      <rect id="Boundary" width="20" height="20" fill="none"/>
      <path :fill="color" id="_Color" data-name=" ↳Color" d="M10.59,0,6,4.574,1.41,0,0,1.408,6,7.4l6-5.992Z" transform="translate(16 14.038) rotate(180)" />
    </g>
  </svg>
</template>

<style lang="scss">

</style>

